/** Logica unica del semaforo usata nei tooltip, chip Hero e grafici.
 *  Soglie asimmetriche configurate via `kpi_threshold_rules` (default: +5% / -5%).
 *  Aggiornate dal contesto quando l'utente le modifica in Impostazioni. */

// Defaults che coincidono con i valori seed del backend (`kpi_threshold_rules`).
export let GREEN_MIN_PCT = 5;
export let RED_MAX_PCT = -5;

/** Aggiorna le soglie live dopo aver caricato `GET /api/kpi/thresholds`. */
export function setThresholds({ green_min, red_max }) {
  if (typeof green_min === 'number') GREEN_MIN_PCT = green_min;
  if (typeof red_max === 'number') RED_MAX_PCT = red_max;
}

/** 'green' se delta >= green_min, 'red' se delta <= red_max, 'yellow' altrimenti.
 *  Null se baseline è 0/null/undefined. */
export function semaphoreVsBaseline(actual, baseline) {
  if (actual == null || baseline == null || baseline === 0) return null;
  const deltaPct = ((actual - baseline) / Math.abs(baseline)) * 100;
  return semaphoreFromPct(deltaPct);
}

/** Semaforo a partire da un delta percentuale già calcolato. */
export function semaphoreFromPct(pct) {
  if (pct == null || Number.isNaN(pct)) return null;
  if (pct >= GREEN_MIN_PCT) return 'green';
  if (pct <= RED_MAX_PCT) return 'red';
  return 'yellow';
}

/** Semaforo per punti percentuali (es. occupancy). Usa soglia in pp proporzionale
 *  (1pp è circa 1.5% relativo su una base 70%). Manteniamo +1/-1 come default
 *  pragmatico finché non avremo una regola dedicata pp. */
export function semaphoreFromPp(pp) {
  if (pp == null || Number.isNaN(pp)) return null;
  if (pp >= 1) return 'green';
  if (pp <= -1) return 'red';
  return 'yellow';
}

/** Classi Tailwind per il testo del chip in base al semaforo.
 *  Usate su sfondo DARK (Hero strips). `amber-500` allineato alla legenda
 *  della bar chart "entro -5%" (bg-amber-500). */
export const SEMAPHORE_TEXT = {
  green: 'text-emerald-500',
  yellow: 'text-amber-500',
  red: 'text-red-500',
};

/** Per sfondo light (pagine bianche) — tinte un po' più scure. */
export const SEMAPHORE_TEXT_LIGHT = {
  green: 'text-emerald-600',
  yellow: 'text-amber-600',
  red: 'text-red-600',
};
